import { isArray, isEmpty, isObject } from 'lodash';

export function constructFilter(filter) {
	if (isEmpty(filter)) {
		return '';
	}
	if (!isArray(filter)) {
		return filter;
	}

	filter = filter
		.map((filterObject) => {
			if (!validFilterObject(filterObject)) {
				console.warn(
					'Invalid filter object in filter array!',
					JSON.stringify(filterObject)
				);
			}
			return (
				filterObject.name +
				':' +
				filterObject.operator +
				(filterObject.value ? ':' + filterObject.value : '')
			);
		})
		.join(' AND ');

	return 'filter=' + encodeURI(filter);
}

export function destructFilter(filterString) {
	if (isEmpty(filterString)) {
		return [];
	}

	filterString = filterString.replace(/^filter=/, '');
	filterString = decodeURI(filterString);
	const filterParts = filterString.split(' AND ');

	return filterParts.map((part) => {
		const [name, operator, ...value] = part.split(':');
		return { name: name, operator: operator, value: value.join(':') };
	});
}

function validFilterObject(filter) {
	if (isEmpty(filter)) {
		return false;
	}

	const keysNumber = Object.keys(filter).length;
	if (keysNumber < 2 || keysNumber > 3) {
		return false;
	}

	if (!filter.hasOwnProperty('name') || !filter.hasOwnProperty('operator')) {
		return false;
	}

	if (isEmpty(filter.name)) return false;
	return !isEmpty(filter.operator);
}

export function constructSort(sort, defaultSort) {
	const sorts = [];
	if (sort && Object.keys(sort).length > 0) {
		const [key, direction] = Object.entries(sort)[0];
		sorts.push({ name: key, direction: direction });
	}
	if (defaultSort) {
		defaultSort = Array.isArray(defaultSort) ? defaultSort : [defaultSort];
		defaultSort.forEach((s) =>
			sorts.push({ name: s.name, direction: s.direction })
		);
	}

	return sorts
		.filter(({ direction }) => direction === 'asc' || direction === 'desc')
		.reduce(
			([sortString, delimiter], { name, direction }) => [
				sortString + delimiter + encodeURI(name + ',' + direction),
				'&sort=',
			],
			['', 'sort=']
		)[0];
}

export function destructSort(sortString) {
	if (isEmpty(sortString)) {
		return {};
	}

	sortString = sortString.replace(/^sort=/, '');
	const sorts = sortString.split('&sort=');

	return sorts.reduce((result, sort) => {
		const [name, direction] = sort.split(',');
		result[name] = direction;
		return result;
	}, {});
}

export function addDefaultSort(sort, defaultSort) {
	return constructSort(destructSort(sort), defaultSort);
}

export function constructPage(page, pageSize) {
	if (isNaN(page) || isNaN(pageSize)) {
		return '';
	}
	return 'page=' + page + '&size=' + pageSize;
}

export function destructPage(pageString) {
	if (isEmpty(pageString)) {
		return undefined;
	}
	pageString = pageString.replace(/^page=/, '');
	const [page, pageSize] = pageString.split('&size=');
	return { page: parseInt(page), size: parseInt(pageSize) };
}

export function constructParameters(page, filter, sort) {
	if (isObject(page)) {
		page = constructPage(page.page, page.size);
	}
	if (isArray(filter)) {
		filter = constructFilter(filter);
	}

	if (isObject(sort)) {
		sort = constructSort(sort);
	}
	return [page, filter, sort].filter((item) => !!item).join('&');
}
